/**
 * "30 e 7" in Italian, "30 and 7" in English: the notice days as a list in the user's language. An
 * unknown language tag makes `Intl.ListFormat` throw a RangeError: the comma list still reads.
 */
export function formatWarningDaysList(warningDays: readonly number[], language: string): string {
  const dayLabels = warningDays.map(String);
  try {
    return new Intl.ListFormat(language, { type: 'conjunction' }).format(dayLabels);
  } catch (error) {
    if (error instanceof RangeError) {
      return dayLabels.join(', ');
    }
    throw error;
  }
}

/** The plural of "giorni" follows the last number of the list: "30 e 1 giorno", "7 e 3 giorni". */
export function warningDaysPluralCount(sortedWarningDays: readonly number[]): number {
  return sortedWarningDays[sortedWarningDays.length - 1] ?? 0;
}
